/**
 * SEO Data for all pages
 * Centralized SEO meta tags, titles, and descriptions
 */

export interface PageSEO {
    title: string;
    description: string;
    keywords?: string;
    canonical?: string;
}

export const seoData: Record<string, PageSEO> = {
    // Home
    home: {
        title: 'Oficina Automóvel em Paços de Ferreira | Roady Centro-Auto Paços de Ferreira',
        description: 'Oficina Roady em Paços de Ferreira: revisões, pneus, mudança de óleo, travões e diagnóstico. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'oficina Paços de Ferreira, pneus Paços de Ferreira, revisão automóvel Paços de Ferreira, mecânica Paços de Ferreira, roady Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/'
    },
    pneus: {
        title: 'Pneus em Paços de Ferreira | Roady Centro-Auto Paços de Ferreira',
        description: 'Pneus para o seu carro em Paços de Ferreira. Aconselhamento na escolha, montagem e equilibragem por técnicos Roady. Peça orçamento sem compromisso.',
        keywords: 'pneus Paços de Ferreira, comprar pneus Paços de Ferreira, montagem pneus',
        canonical: 'https://roadypacosferreira.com/loja/pneus'
    },

    // Workshop (Services Overview)
    workshop: {
        title: 'Serviços de Oficina em Paços de Ferreira | Roady Centro-Auto Paços de Ferreira',
        description: 'Revisão, pneus, óleo, travões, alinhamento e diagnóstico em Paços de Ferreira. Veja todos os serviços do Roady Paços de Ferreira e peça orçamento sem compromisso.',
        keywords: 'serviços automóvel Paços de Ferreira, oficina Paços de Ferreira, mecânica Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/oficina'
    },

    // Service Details
    'revisoes-roady': {
        title: 'Revisão Automóvel em Paços de Ferreira | Roady Centro-Auto Paços de Ferreira',
        description: 'Revisão completa em Paços de Ferreira, sem perder a garantia do seu carro. Veja o que está incluído e peça orçamento sem compromisso.',
        keywords: 'revisão automóvel Paços de Ferreira, revisão carro Paços de Ferreira, manutenção automóvel',
        canonical: 'https://roadypacosferreira.com/oficina/revisoes-roady'
    },
    'alinhamento': {
        title: 'Alinhamento de Direção no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira',
        description: 'Alinhamento profissional em Paços de Ferreira. Menos desgaste nos pneus, condução segura e precisa. Peça orçamento sem compromisso.',
        keywords: 'alinhamento Paços de Ferreira, alinhamento direção Paços de Ferreira, geometria Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/oficina/alinhamento'
    },
    'teste-diagnostico': {
        title: 'Diagnóstico Eletrónico no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira',
        description: 'Diagnóstico eletrónico completo para todas as marcas. Identificação rápida e precisa de avarias. Roady Centro-Auto Paços de Ferreira.',
        keywords: 'diagnóstico automóvel Paços de Ferreira, teste eletrónico Paços de Ferreira, diagnóstico carro',
        canonical: 'https://roadypacosferreira.com/oficina/teste-diagnostico'
    },
    'travoes': {
        title: 'Serviço de Travões no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira',
        description: 'Substituição de pastilhas e discos de travão no Paços de Ferreira. Segurança garantida com profissionais Roady.',
        keywords: 'travões Paços de Ferreira, pastilhas travão Paços de Ferreira, discos travão Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/oficina/travoes'
    },
    'amortecedores': {
        title: 'Amortecedores no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira | Troca e Revisão',
        description: 'Troca e revisão de amortecedores no Paços de Ferreira. Estabilidade e segurança com serviço Roady certificado.',
        keywords: 'amortecedores Paços de Ferreira, suspensão Paços de Ferreira, troca amortecedores',
        canonical: 'https://roadypacosferreira.com/oficina/amortecedores'
    },
    'inspecao': {
        title: 'Pré-Inspeção Automóvel no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira',
        description: 'Prepare o seu carro para a inspeção com o serviço Roady no Paços de Ferreira. Verificação completa e rápida.',
        keywords: 'pré-inspeção Paços de Ferreira, inspeção automóvel Paços de Ferreira, preparação inspeção',
        canonical: 'https://roadypacosferreira.com/oficina/inspecao'
    },
    'mecanica-geral': {
        title: 'Mecânica Automóvel no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira',
        description: 'Mecânica automóvel completa no Paços de Ferreira. Reparações e manutenção com técnicos especializados Roady.',
        keywords: 'mecânica geral Paços de Ferreira, reparação automóvel Paços de Ferreira, mecânico Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/oficina/mecanica-geral'
    },
    'ar-condicionado': {
        title: 'Carregamento de Ar Condicionado Auto em Paços de Ferreira | Roady',
        description: 'Carregamento e manutenção do ar condicionado do seu carro em Paços de Ferreira. Saiba quando é preciso e peça orçamento sem compromisso.',
        keywords: 'ar condicionado auto Paços de Ferreira, carga AC Paços de Ferreira, reparação AC automóvel',
        canonical: 'https://roadypacosferreira.com/oficina/ar-condicionado'
    },
    'baterias': {
        title: 'Baterias Automóvel no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira',
        description: 'Teste e substituição de baterias automóvel no Paços de Ferreira. Instalação com garantia Roady.',
        keywords: 'baterias auto Paços de Ferreira, bateria carro Paços de Ferreira, substituição bateria',
        canonical: 'https://roadypacosferreira.com/oficina/baterias'
    },
    'restauro-farois': {
        title: 'Restauro de Faróis no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira',
        description: 'Restauro profissional de faróis automóvel. Melhore a visibilidade e segurança. Roady Paços de Ferreira.',
        keywords: 'restauro faróis Paços de Ferreira, polimento faróis Paços de Ferreira, recuperação faróis',
        canonical: 'https://roadypacosferreira.com/oficina/restauro-farois'
    },
    'lavagem': {
        title: 'Lavagem Auto no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira',
        description: 'Serviços de lavagem automóvel completos no Paços de Ferreira. Interior e exterior com profissionais Roady.',
        keywords: 'lavagem auto Paços de Ferreira, limpeza carro Paços de Ferreira, lavagem completa',
        canonical: 'https://roadypacosferreira.com/oficina/lavagem'
    },
    'servicos-oficina': {
        title: 'Plano de Serviços Oficina — Roady Centro-Auto Paços de Ferreira',
        description: 'Planos de serviços e manutenção para a sua oficina. Soluções completas Roady no Paços de Ferreira.',
        keywords: 'plano serviços Paços de Ferreira, manutenção oficina Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/oficina/servicos-oficina'
    },

    // Store & Categories
    store: {
        title: 'Loja Auto no Paços de Ferreira — Roady Centro-Auto Paços de Ferreira | Peças e Acessórios',
        description: 'Óleos, acessórios, produtos auto, limpeza e manutenção. Loja Roady Paços de Ferreira.',
        keywords: 'loja auto Paços de Ferreira, peças automóvel Paços de Ferreira, acessórios auto Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/loja'
    },
    'loja-eletricidade': {
        title: 'Eletricidade Automóvel — Loja Roady Paços de Ferreira',
        description: 'Componentes elétricos, baterias e acessórios elétricos para automóvel. Roady Paços de Ferreira.',
        keywords: 'eletricidade auto Paços de Ferreira, componentes elétricos carro',
        canonical: 'https://roadypacosferreira.com/loja/eletricidade'
    },
    'loja-equipamento-interior': {
        title: 'Equipamento Interior Auto — Loja Roady Paços de Ferreira',
        description: 'Acessórios e equipamentos para interior do automóvel. Qualidade garantida Roady.',
        keywords: 'equipamento interior auto, acessórios interior carro Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/loja/equipamento-interior'
    },
    'loja-equipamento-exterior': {
        title: 'Equipamento Exterior Auto — Loja Roady Paços de Ferreira',
        description: 'Acessórios e equipamentos para exterior do automóvel. Loja Roady Paços de Ferreira.',
        keywords: 'equipamento exterior auto, acessórios exterior carro Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/loja/equipamento-exterior'
    },
    'loja-lubrificantes': {
        title: 'Lubrificantes e Óleos Auto — Loja Roady Paços de Ferreira',
        description: 'Óleos motor, lubrificantes e produtos de manutenção. Marcas de confiança no Roady Paços de Ferreira.',
        keywords: 'óleo motor Paços de Ferreira, lubrificantes auto Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/loja/lubrificantes'
    },
    'loja-manutencao': {
        title: 'Produtos de Manutenção Auto — Loja Roady Paços de Ferreira',
        description: 'Produtos de manutenção e cuidado automóvel. Roady Paços de Ferreira.',
        keywords: 'produtos manutenção auto, cuidado automóvel Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/loja/manutencao'
    },
    'loja-pecas-tecnicas': {
        title: 'Peças Técnicas Auto — Loja Roady Paços de Ferreira',
        description: 'Peças técnicas e componentes para automóvel. Qualidade garantida Roady.',
        keywords: 'peças técnicas auto Paços de Ferreira, componentes carro',
        canonical: 'https://roadypacosferreira.com/loja/pecas-tecnicas'
    },
    'loja-pneus': {
        title: 'Pneus em Paços de Ferreira | Roady Centro-Auto Paços de Ferreira',
        description: 'Pneus para o seu carro em Paços de Ferreira. Aconselhamento na escolha, montagem e equilibragem por técnicos Roady. Peça orçamento sem compromisso.',
        keywords: 'pneus Paços de Ferreira, comprar pneus Paços de Ferreira, montagem pneus',
        canonical: 'https://roadypacosferreira.com/loja/pneus'
    },
    'loja-som-multimedia-navegacao': {
        title: 'Som, Multimédia e Navegação — Loja Roady Paços de Ferreira',
        description: 'Sistemas de som, multimédia e navegação GPS para automóvel. Roady Paços de Ferreira.',
        keywords: 'som auto Paços de Ferreira, GPS carro Paços de Ferreira, multimédia automóvel',
        canonical: 'https://roadypacosferreira.com/loja/som-multimedia-navegacao'
    },
    'loja-ferramentas': {
        title: 'Ferramentas Auto — Loja Roady Paços de Ferreira',
        description: 'Ferramentas profissionais e acessórios para manutenção automóvel. Roady Paços de Ferreira.',
        keywords: 'ferramentas auto Paços de Ferreira, ferramentas mecânica',
        canonical: 'https://roadypacosferreira.com/loja/ferramentas'
    },

    // Other Pages
    budget: {
        title: 'Peça Orçamento Automóvel em Paços de Ferreira | Roady Paços de Ferreira',
        description: 'Peça orçamento para revisão, pneus, travões ou mudança de óleo no Roady Paços de Ferreira. Diga-nos o que o carro precisa e respondemos com um valor claro.',
        keywords: 'orçamento auto Paços de Ferreira, pedir orçamento oficina Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/orcamento'
    },
    mobility: {
        title: 'Mobilidade Urbana Paços de Ferreira — Roady Centro-Auto Paços de Ferreira',
        description: 'Bicicletas e trotinetes elétricas no Paços de Ferreira. Assistência e apoio Roady.',
        keywords: 'mobilidade Paços de Ferreira, bicicletas elétricas Paços de Ferreira, trotinetes Paços de Ferreira',
        canonical: 'https://roadypacosferreira.com/mobilidade'
    },
    recruitment: {
        title: 'Recrutamento — Roady Centro-Auto Paços de Ferreira',
        description: 'Junte-se à equipa Roady Centro-Auto Paços de Ferreira. Procuramos talento para o setor automóvel. Envie candidatura.',
        keywords: 'emprego Paços de Ferreira, trabalho oficina Paços de Ferreira, recrutamento roady',
        canonical: 'https://roadypacosferreira.com/recrutamento'
    },
    contact: {
        title: 'Contactos e Horário | Roady Centro-Auto Paços de Ferreira',
        description: 'Morada, horário, telefone e WhatsApp do Roady Centro-Auto Paços de Ferreira. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'contacto roady Paços de Ferreira, telefone oficina Paços de Ferreira, morada roady',
        canonical: 'https://roadypacosferreira.com/contacto'
    },
    wecall: {
        title: 'Ligamos-lhe — Roady Centro-Auto Paços de Ferreira',
        description: 'Deixe os seus dados e ligamos-lhe. Atendimento personalizado Roady Paços de Ferreira.',
        keywords: 'contacto roady Paços de Ferreira, ligação gratuita',
        canonical: 'https://roadypacosferreira.com/ligamos'
    },
    wishlist: {
        title: 'Lista de Desejos — Roady Centro-Auto Paços de Ferreira',
        description: 'Guarde os seus produtos favoritos na lista de desejos. Loja Roady Paços de Ferreira.',
        canonical: 'https://roadypacosferreira.com/lista-desejos'
    },

    // Legal Pages
    cookies: {
        title: 'Política de Cookies — Roady Centro-Auto Paços de Ferreira',
        description: 'Política de cookies do website Roady Centro-Auto Paços de Ferreira. Saiba como utilizamos cookies.',
        canonical: 'https://roadypacosferreira.com/politica-cookies'
    },
    privacy: {
        title: 'Política de Privacidade — Roady Centro-Auto Paços de Ferreira',
        description: 'Política de privacidade e proteção de dados do Roady Centro-Auto Paços de Ferreira.',
        canonical: 'https://roadypacosferreira.com/politica-privacidade'
    },
    terms: {
        title: 'Termos e Condições — Roady Centro-Auto Paços de Ferreira',
        description: 'Termos e condições de utilização do website Roady Centro-Auto Paços de Ferreira.',
        canonical: 'https://roadypacosferreira.com/termos-condicoes'
    }
};

/**
 * Get SEO data for a service page
 */
export const getServiceSEO = (serviceSlug: string): PageSEO => {
    return seoData[serviceSlug] || seoData.workshop;
};

/**
 * Get SEO data for a store category page
 */
export const getStoreCategorySEO = (categorySlug: string): PageSEO => {
    const key = `loja-${categorySlug}`;
    return seoData[key] || seoData.store;
};

